export { Cmodal } from './Cmodal';
export type { CmodalProps } from './Cmodal.types';
